import { render } from "./Anmo.vue?vue&type=template&id=4767ec2c&scoped=true"
import script from "./Anmo.vue?vue&type=script&lang=js"
export * from "./Anmo.vue?vue&type=script&lang=js"

import "./Anmo.vue?vue&type=style&index=0&id=4767ec2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4767ec2c"]])

export default __exports__